/**
 * dsTag — dev-only DOM marker identifying a canonical design-system component.
 *
 * Spread onto a component's root element ({...dsTag("Button")}). The design
 * playground inspector (/dev/designs) uses the attribute to tell real ds
 * components from hand-rolled lookalikes. Compiles away in production builds,
 * so the prod DOM stays clean.
 */
export const dsTag = (name: string): Record<string, string> =>
  import.meta.env.DEV ? { "data-ds": name } : {};
